import StatusBadge from "@/components/StatusBadge";
import {textDirectionLabels} from "@/constant/Languages/text-direction";

const textDirectionLabelsMap = textDirectionLabels();

export const columns = () => {
  return [
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    },
    {
      accessorKey: "order",
      header: "Order",
      size: 60,
      cell: ({ row }) => <div className={"flex justify-center"}>{row.getValue("order")}</div>,
    },
    {
      accessorKey: "title",
      header: "Language",
      cell: ({ row }) => (
        <div className="flex gap-2 items-center">
          <div className="flex w-8">
            <img src={row.original.icon_url} alt="icon" />
          </div>
          <div>{row.original.title}</div>
        </div>
      ),
    },
    {
      accessorKey: "code",
      header: "2-Letter Code",
    },
    {
      accessorKey: "code_alpha_3",
      header: "3-Letter Code",
    },
    {
      accessorKey: "label",
      header: "Label",
    },
    {
      accessorKey: "slug",
      header: "Slug",
    },
    {
      accessorKey: "rtl",
      header: "Text Direction",
      accessorFn: (row) => textDirectionLabelsMap[row.rtl],
    },
  ];
};
